import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import WebinarCountdownBar from "./webinarCountdownBar";

const HomeNavbar = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    // Detect scroll past hero section
    useEffect(() => {
        const handleScroll = () => {
            const heroHeight = window.innerHeight * 0.9; // 90% of screen height
            setScrolled(window.scrollY > heroHeight);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // Decide navbar style (global scroll for every page)
    const isTransparent = !scrolled;
    const isHome = location.pathname === "/";


    return (
        <div className="fixed w-full top-0 z-50">
            {isHome && <WebinarCountdownBar />}
            <nav
                className={`w-full transition-all duration-300 ${isTransparent
                    ? "bg-transparent border-b border-white/30"
                    : "bg-white  border-b border-white/30 shadow-md"
                    }`}
            >
            <div className="container mx-auto px-6 py-4 flex justify-between items-center">
                <div
                    onClick={() => navigate("/")}
                    className={`text-3xl font-bold tracking-wide cursor-pointer ${isTransparent ? "text-white" : "text-[#2148C0]"
                        }`}
                >
                    TeeChaa
                </div>

                {/* Desktop Menu */}
                <div className="hidden md:flex space-x-8 items-center">
                    {["/", "/about", "/features", "/pricing", "/contact-us"].map((path, i) => {
                        const labels = ["Home", "About", "Features", "Pricing", "Contact"];
                        return (
                            <Link
                                key={path}
                                to={path}
                                className={`text-lg ${isTransparent
                                    ? "text-white hover:text-gray-300"
                                    : "text-gray-800 hover:text-[#2148C0]"
                                    }`}
                            >
                                {labels[i]}
                            </Link>
                        );
                    })}
                    <button
                        onClick={() =>
                            // navigate("/#waitlist")
                            navigate("/login")
                        }

                        className={`px-6 py-2 rounded-full text-lg font-semibold transition-all duration-300 ${isTransparent
                            ? "bg-white/20 text-white border border-white/40 hover:bg-white/30"
                            : "bg-[#2148C0] text-white hover:bg-blue-700"
                            }`}
                    >
                        Login
                    </button>
                </div>

                {/* Mobile Menu Button */}
                <div
                    className={`md:hidden text-2xl cursor-pointer ${isTransparent ? "text-white" : "text-gray-700"
                        }`}
                    onClick={toggleMobileMenu}
                >
                    {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
                </div>
            </div>

            {/* Mobile Menu */}
            {
                isMobileMenuOpen && (
                    <div
                        className={`md:hidden text-center p-3 shadow-lg border-t ${isTransparent
                            ? "bg-black/60 backdrop-blur-md border-white/30"
                            : "bg-white/70 backdrop-blur-md border-white/30"
                            }`}
                    >
                        {["/", "/about", "/features", "/pricing", "/contact-us"].map((path, i) => {
                            const labels = ["Home", "About", "Features", "Pricing", "Contact"];
                            return (
                                <Link
                                    key={path}
                                    to={path}
                                    onClick={toggleMobileMenu}
                                    className={`block py-3 ${isTransparent
                                        ? "text-white hover:text-gray-300"
                                        : "text-gray-800 hover:text-[#2148C0]"
                                        }`}
                                >
                                    {labels[i]}
                                </Link>
                            );
                        })}
                        <button
                            onClick={() => {
                                toggleMobileMenu();
                                navigate("/login");
                                // navigate("/#waitlist");
                            }}
                            className={`px-6 py-2 rounded-full text-lg font-semibold mt-4 transition-all duration-300 ${isTransparent
                                ? "bg-white/20 text-white border border-white/40 hover:bg-white/30"
                                : "bg-[#2148C0] text-white hover:bg-blue-700"
                                }`}
                        >
                            Login
                        </button>
                    </div>
                )
            }
            </nav>
        </div>
    );
};

export default HomeNavbar;
